/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Filter_StartInputs */

const en_gc_resources_filter_start = /** @type {(inputs: Gc_Resources_Filter_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting started`)
};

const zh_gc_resources_filter_start = /** @type {(inputs: Gc_Resources_Filter_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入门`)
};

/**
* | output |
* | --- |
* | "Getting started" |
*
* @param {Gc_Resources_Filter_StartInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_filter_start = /** @type {((inputs?: Gc_Resources_Filter_StartInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Filter_StartInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_filter_start(inputs)
	return zh_gc_resources_filter_start(inputs)
});
export { gc_resources_filter_start as "gc.resources.filter.start" }